module.exports = __webpack_public_path__ + "static/media/cluster-mockup-1.81d1d3af.jpg";